import axios from 'axios'

let baseUrl = 'http://localhost:9292/v1'

if(process.env.NODE_ENV == 'production') {
  baseUrl = 'https://api.lmdelivers.com/v1'
}

const instance = axios.create()

instance.defaults.headers.common['Authorization'] = localStorage.token
instance.defaults.baseUrl = baseUrl

instance.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (401 === error.response.status) {
    localStorage.token = ''
    window.location = '/';
  } else {
    return Promise.reject(error);
  }
});

// const requestHandler = (request) => {
//   $("#logo").addClass("rotate")
//   return request
// }

// const errorHandler = (error) => {
//   $("#logo").removeClass("rotate")
//   return Promise.reject({ ...error })
// }

// const successHandler = (response) => {
//   $("#logo").removeClass("rotate")
//   return response
// }

// instance.interceptors.request.use(
//   request => requestHandler(request),
// )

// instance.interceptors.response.use(
//   response => successHandler(response),
//   error => errorHandler(error)
// )

export default {
  baseUrl,

  get(url) {
    return instance.get(baseUrl + url)
  },

  post(url, params) {
    return instance.post(baseUrl + url, params)
  }
}

// 640okiop;rkajs.ds,,mbnz.,k<